module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/globe.aafa3087da57ebbe00ee096bce40980d.svg";